angular.module('gym.payers').controller('EzidebitImportCtrl', ["$rootScope", "$scope", "$state", "$modal", "$window", "$timeout", "$http", "ngTableParams", "EzidebitPayers", "loadingAnimation", "MasqueradingService", "ActionCable", "AdminUserService", "ReactModal", "flash", function($rootScope, $scope, $state, $modal, $window, $timeout, $http, ngTableParams, EzidebitPayers, loadingAnimation, MasqueradingService, ActionCable, AdminUserService, ReactModal, flash) {
  var gym, unsubscribe;
  $scope.gym = gym = $rootScope.gym;
  $scope.queryParams = {
    'filters[link_status]': 'not_linked',
    'filters[duplicate_status]': 'exclude'
  };
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  if (!$scope.isMasquerading || !AdminUserService.has('admin_manage_contact_payment_methods')) {
    $state.go('gym.dashboard');
  }
  $scope.pageParams = {
    filtersOpen: true
  };
  $scope.linkStatuses = [
    {
      name: 'Linked',
      value: 'linked'
    },
    {
      name: 'Unlinked',
      value: 'not_linked'
    }
  ];
  $scope.duplicateStatuses = [
    {
      name: 'Exclude duplicates',
      value: 'exclude'
    },
    {
      name: 'Only show duplicates',
      value: 'only'
    }
  ];
  $scope.linkCandidateStatuses = [
    {
      name: 'Has link candidates',
      value: 'present'
    }
  ];
  $scope.statusCodes = [
    {
      name: 'Active',
      value: 'A'
    },
    {
      name: 'Hold',
      value: 'H'
    },
    {
      name: 'Cancelled',
      value: 'C'
    }
  ];
  $scope.sync = function() {
    return ReactModal.open({
      component: 'SyncEzidebitPayersModal'
    }).then(function() {
      return $scope.syncing = true;
    });
  };
  unsubscribe = ActionCable.create({
    channel: "EzidebitCustomerSyncChannel",
    gym_id: $scope.gym.id
  }, function(message) {
    return $timeout(function() {
      var ref;
      if (message.progress_message) {
        $scope.syncing = true;
        $scope.progressMessage = message.progress_message;
      }
      if ((ref = message.message) === 'sync_complete' || ref === 'sync_failed') {
        $scope.progressMessage = void 0;
        $scope.syncing = false;
        return $scope.tableParams.reload();
      }
    });
  });
  $scope.$on('$destroy', function() {
    return unsubscribe();
  });
  $scope.toggleFilters = function() {
    return $scope.pageParams.filtersOpen = !$scope.pageParams.filtersOpen;
  };
  $scope.toggleFiltersModal = function() {
    var filtersModal;
    filtersModal = $modal.open({
      template: require('templates/gyms/payers/ezidebit_payers_filters_modal.html.slim'),
      resolve: {
        options: function() {
          return {
            linkStatuses: $scope.linkStatuses,
            duplicateStatuses: $scope.duplicateStatuses,
            linkCandidateStatuses: $scope.linkCandidateStatuses,
            statusCodes: $scope.statusCodes
          };
        },
        filters: function() {
          return $scope.queryParams;
        }
      },
      controller: 'FiltersModalCtrl'
    });
    return filtersModal.result.then(function(result) {
      $scope.queryParams = result;
      return $scope.tableParams.reload();
    });
  };
  $scope.onSearch = _.debounce((function(request) {
    return $scope.tableParams.reload();
  }), 500);
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      var params;
      loadingAnimation.show();
      params = angular.extend($params.url(), $scope.queryParams);
      EzidebitPayers.customGET('meta').then(function(meta) {
        return $scope.meta = meta;
      });
      return EzidebitPayers.getList(params).then(function(data) {
        $params.total(data.meta.total);
        loadingAnimation.hide();
        return $defer.resolve(data);
      });
    }
  });
  $scope.showLinkModal = function(payer) {
    var linkModal;
    linkModal = $modal.open({
      template: require('templates/gyms/payers/link_modal.html.slim'),
      resolve: {
        payer: function() {
          return payer;
        },
        type: function() {
          return 'ezidebit_payers';
        }
      },
      controller: 'LinkPayerModalCtrl'
    });
    return linkModal.result.then(function() {
      return $scope.tableParams.reload();
    });
  };
  $scope.quickLinkPayer = function(payer, contact) {
    var message, payerDetails, url;
    payerDetails = `${payer.first_name} ${payer.last_name} (${payer.your_system_reference})`;
    message = `This will link the payer ${payerDetails} to ${contact.contact_name} (${contact.contact_email}). Are you sure?`;
    if ($window.confirm(message)) {
      url = `/gyms/${gym.id}/ezidebit_payers/${payer.id}?contact_id=${contact.contact_id}`;
      return $http.put(url).then(function() {
        $scope.tableParams.reload();
        return flash.success = "Payer successfully linked";
      }, function(response) {
        return flash.error = response.data.error || "Request could not be completed. Please try again";
      });
    }
  };
  $scope.markDuplicate = function(payer) {
    var message, payerDetails, url;
    payerDetails = `${payer.first_name} ${payer.last_name} (${payer.your_system_reference})`;
    message = `This will mark the payer ${payerDetails} as a duplicate, which means they will no longer show in this table when duplicates are filtered out. Are you sure?`;
    if ($window.confirm(message)) {
      url = `/gyms/${gym.id}/ezidebit_payers/${payer.id}/mark_duplicate`;
      return $http.put(url).then(function() {
        $scope.tableParams.reload();
        return flash.success = "Payer successfully marked duplicate";
      }, function(response) {
        return flash.error = response.data.error || "Request could not be completed. Please try again";
      });
    }
  };
  return $scope.unMarkDuplicate = function(payer) {
    var message, url;
    message = "This will remove this payer's duplicate status. Are you sure?";
    if ($window.confirm(message)) {
      url = `/gyms/${gym.id}/ezidebit_payers/${payer.id}/undo_duplicate`;
      return $http.put(url).then(function() {
        $scope.tableParams.reload();
        return flash.success = "Payer successfully unmarked as a duplicate";
      }, function(response) {
        return flash.error = response.data.error || "Request could not be completed. Please try again";
      });
    }
  };
}]);
